import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyDataService extends BaseHttpService {
    private urls = {
        allCompanyLocations: '/companies/:companyId/locations?all=true',
        features: '/companies/:companyId/features',
        getCompany: '/company?include=skills',
        company: '/companies/:companyId',
        companyAvatar: '/companies/:companyId/avatar',
    };

    protected override initApiEndpoint() {
        this.apiEndpoint = environment.api.endpointV2;
    }

    fetchCompany(): Observable<any> {
        return this.get(this.urls.getCompany);
    }

    fetchAllCompanyLocations(companyId: string): Observable<any> {
        return this.get(
            this.urls.allCompanyLocations.replace(':companyId', companyId)
        );
    }

    fetchCompanyFeatures(companyId: string): Observable<any> {

        const url = environment.api.endpoint + this.urls.features.replace(':companyId', companyId);
        return this.get(url, undefined, true);
    }

    // updateCompany(
    //     companyId: string,
    //     request: CompanyUpdateRequest
    // ): Observable<any> {
    //     const requestUrl: string = this.urls.company.replace(
    //         ':companyId',
    //         companyId
    //     );
    //     return this.put(requestUrl, request);
    // }
}
